import { TEmptyScreen } from "@shared/cms";
import Image from "next/image";

export function EmptyScreen({ title, description }: TEmptyScreen) {
  return (
    <div className="flex items-center justify-center text-center gap-6 flex-col w-full mx-auto max-w-md py-10">
      <Image src="/empty-state.webp" width="200" height="100" className="object-contain" alt="empty-state" />
      <div className="flex flex-col gap-4">
        <h4 className="text-base sm:text-lg font-bold">{title}</h4>
        <p className="text-sm sm:text-base text-gray-500">{description}</p>
      </div>
    </div>
  );
}
